module.exports = __webpack_public_path__ + "static/dmm-product-screenshot@2x-dd74d73ddaaac59fb9fac31ad883f530.png";